import { render, staticRenderFns } from "./Contacts2.vue?vue&type=template&id=a10e5294&scoped=true&"
import script from "./Contacts2.vue?vue&type=script&lang=ts&"
export * from "./Contacts2.vue?vue&type=script&lang=ts&"
import style0 from "./Contacts2.vue?vue&type=style&index=0&id=a10e5294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e5294",
  null
  
)

export default component.exports